import React from "react";

const useReorderList = <T>(initialItems: T[]) => {
  const [items, setItems] = React.useState(initialItems);

  React.useEffect(() => {
    setItems(initialItems);
  }, [initialItems]);

  const moveItem = (fromIndex: number, toIndex: number) => {
    if (toIndex < 0 || toIndex >= items.length) return;
    const updated = [...items];
    const [movedItem] = updated.splice(fromIndex, 1);
    updated.splice(toIndex, 0, movedItem);
    setItems(updated);
  };

  const moveUp = (index: number) => moveItem(index, index - 1);
  const moveDown = (index: number) => moveItem(index, index + 1);
  const moveToTop = (index: number) => moveItem(index, 0);
  const moveToBottom = (index: number) => moveItem(index, items.length - 1);

  return {
    items,
    moveUp,
    moveDown,
    moveToTop,
    moveToBottom,
  };
};

export default useReorderList;
